var terms = {
        init: function() {
            $('#document').on('click', '.show-terms', function(e) {
                e.preventDefault();

                var that = $(this),
                    mode = $(this).data('tab'),
                    url = that.attr('href'),
                    initHandler = $('#initTerms'),
                    originalHandler = $('#originalTerms'),
                    container = $('.terms-container');

                $('.show-terms').removeClass('active');
                that.addClass('active');

                if (mode === 'original') {
                    container.addClass('loading');

                    if ($(this).hasClass('loaded')) {
                        initHandler.hide();
                        originalHandler.show();
                        container.removeClass('loading');
                    } else {
                        $.postJSON(url, function(response) {
                            if (!response.error) {
                                initHandler.hide();
                                originalHandler.html(response.html);
                                container.removeClass('loading');
                                that.addClass('loaded');
                            }
                        });
                    }

                    $('.expand-initial').hide();
                    $('.expand-original').show();
                } else {
                    originalHandler.hide();
                    initHandler.show();
                    $('.expand-original').hide();
                    $('.expand-initial').show();
                }
            });

            // expand all
            $(document).on('click', '.expand-collapse', function(e) {
                e.preventDefault();

                var $this = $(this),
                    expand = $this.data('expand'),
                    collapse = $this.data('collapse');

                $this.toggleClass('collapse');

                if ($this.hasClass('collapse')) {
                    $this.text(collapse);
                    $('.terms-header:visible').addClass('opened').next().slideDown();
                } else {
                    $this.text(expand);
                    $('.terms-header:visible').removeClass('opened').next().slideUp();
                }
            }).on('click', '.terms-header', function(e) {
                e.stopPropagation();
                $(this).toggleClass('opened').next().slideToggle();
            });
        }
    };
